import PaymentIntentCardNew from 'components/cards/payment_intent_new';

const PaymentIntents = ({ paymentIntents = [] }) => {
  return (
    <section
      style={{ backgroundColor: 'white', gap: '2px', paddingTop: '25px' }}
      className="flex flex-column"
    >
      {paymentIntents.map((paymentIntent) => (
        <div
          key={paymentIntent.id}
          style={{
            padding: '0px 24px',
            background: 'white',
          }}
        >
          <PaymentIntentCardNew paymentIntent={paymentIntent} />
        </div>
      ))}
    </section>
  );
};

export default PaymentIntents;
